import { APIFactory, factory } from './../api';

const ModuleName = 'RessieApp';

export class CardAPI extends APIFactory {

  /* @ngInject */
  constructor(...args) {
    super(...args);
    this.actions = {
      charge: {
        method: 'PUT',
        auth: false,
        url: `${this.api.getDomain()}/card/:id`,
        params: { id: '@id' },
        isArray: false,
      },
      refund: {
        method: 'PUT',
        url: `${this.api.getDomain()}/charge/:id`,
        params: { id: '@id' },
        auth: false,
        isArray: false
      }
    };
  }

  get url() {
    return `${this.api.getDomain()}/gift/:id`;
  }

  setAction(name, obj) {
    this.actions[name] = obj;
  }

};

export const API = (MODULE) => {
  return factory(MODULE, 'CardAPI', CardAPI);
}

export default () => {
  return API(ModuleName);
};




// WEBPACK FOOTER //
// ./client/assets/scripts/modules/card/api.js